import $ from 'jquery';

class CaseList {
    constructor(el) {
        this.$el = $(el);
        this.$itemsContainer = this.$el.find('.js-filtered-list-items');
        this.$items = this.$itemsContainer.children();
        this.$showAll = this.$el.find('.js-filtered-list-show-all');

        if (this.$items.filter('.filter-hidden').length) {
            this.events();
        } else {
            this.showAll();
        }
    }

    events() {
        this.$showAll.on('click', e => {
            e.preventDefault();

            this.showAll();
        });
    }

    showAll() {
        this.$itemsContainer.addClass('fade-out');
        this.$itemsContainer.addClass('is-all');
        this.$items.removeClass('filter-hidden');
        this.$itemsContainer.removeClass('fade-out');
    }
}

export default CaseList;



// WEBPACK FOOTER //
// ./sources/js/components/case-list.js